import React, { useEffect, useState } from 'react';
import { Drawer, message, notification, Spin } from 'antd';
import { isMobile } from 'react-device-detect';
import api from '../../utils/api';

import FileDownload from 'js-file-download';
import PortalLoading from '../../components/PortalLoading';

interface Props {
    quote_id: number | null;
    onClose: () => void;
    open: boolean;
}

const QuotePreview = ({ quote_id, onClose, open }: Props) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [fileURL, setFileURL] = useState<string>('');

    useEffect(() => {
        setLoading(true);
        if (quote_id) {
            api.Quotes.downloadQuote(quote_id)
                .then(data => {
                    if (isMobile) {
                        FileDownload(data, `quote-${quote_id}.pdf`);
                        onClose();
                        notification.success({ message: 'Document downloaded' });
                    } else {
                        const file = new Blob([data], { type: 'application/pdf' });

                        const fileURL = URL.createObjectURL(file);

                        setLoading(false);
                        setFileURL(fileURL);
                    }
                })
                .catch(error => message.error(error));
        }
    }, [quote_id]);

    if (isMobile) {
        return null;
    }

    return (
        <Drawer
            title="Preview"
            closable
            open={open}
            placement={'right'}
            onClose={onClose}
            width={'auto'}
            bodyStyle={{ padding: 0, width: '95vw', overflowY: 'hidden', maxWidth: '720px' }}
        >
            {!quote_id || loading ? (
                <PortalLoading />
            ) : (
                <iframe
                    title={'Quote Preview'}
                    src={fileURL}
                    frameBorder="0"
                    height={window.innerHeight}
                    width="100%"
                />
            )}
        </Drawer>
    );
};

export default QuotePreview;
